document.querySelectorAll('.splitkon-show-more-info-box__content')?.forEach((content) => {
    const button = content.nextElementSibling.querySelector(':scope .wp-element-button');
    button.addEventListener( 'click', () => {
        content.classList.toggle( 'splitkon-show-more-info-box__content--opened' )
        content.classList.contains( 'splitkon-show-more-info-box__content--opened' )
            ? button.innerHTML = 'Vis mindre'
            : button.innerHTML = 'Vis mer'
    } )
});
